import React from 'react'

const PoliticaDeServicio = () => {
  return (
    <main className="site-width pagina-politica">
      <h2>Política del Servicio</h2>

      <p>
        En <em>Barber Mujica</em> nos tomamos muy en serio tu tiempo… y el nuestro también.
        Para ofrecer un servicio profesional, puntual y justo para todos, es necesario que cada cliente
        acepte y respete las siguientes normas al hacer uso de nuestra plataforma de reservas online:
      </p>
      <h3>1. Compromiso con la cita</h3>
      <p>
        Al reservar una cita en nuestra web, el cliente se compromete a acudir a la hora elegida.
        Si el cliente <strong>no se presenta sin previo aviso</strong>, deberá abonar el <strong>50% del importe del servicio reservado</strong> en la siguiente cita.
        Esta penalización compensa el tiempo bloqueado que no ha podido aprovecharse.
      </p>
      <p>
        Las cancelaciones deben realizarse con al menos <strong>12 horas de antelación</strong> desde la plataforma.
        Si no se cumple este plazo, se considerará una falta de asistencia.
      </p>
      <h3>2. Faltas reiteradas</h3>
      <p>
        El compromiso y la puntualidad son esenciales. Si un cliente acumula <strong>varias faltas de asistencia o cancelaciones tardías</strong>,
        su perfil podrá ser <strong>bloqueado temporalmente</strong> o incluso <strong>de forma permanente</strong>, según la gravedad de los casos.
      </p>
      <p>
        Esto garantiza la disponibilidad para quienes valoran el servicio y respetan la agenda del barbero.
      </p>
      <h3>3. Contacto solo por WhatsApp</h3>
      <p>
        Cualquier duda o incidencia relacionada con tu cita debe resolverse <strong>a través de la web</strong>.
        Solo en casos excepcionales se podrá contactar <strong>vía WhatsApp</strong>, como problemas técnicos, cambios urgentes o dudas específicas
        <strong> que no se puedan gestionar desde la plataforma</strong>.
      </p>
      <p>
        👉 <strong>No se atenderán llamadas telefónicas.</strong><br />
        El número de contacto no está habilitado para realizar reservas, resolver preguntas frecuentes o coordinar citas por teléfono.
      </p>
      <h3>4. Nombre y número reales</h3>
      <p>
        Al hacer una reserva es <strong>obligatorio introducir tu nombre real y número de teléfono activo</strong>.
        Si detectamos el uso de nombres falsos, de broma o con carácter ofensivo,
        el sistema podrá <strong>bloquear de forma inmediata el acceso a la plataforma</strong>.
      </p>
      <p>
        Este control busca garantizar una atención personalizada, profesional y segura para todos.
      </p>
      <h3>5. Buen uso del servicio</h3>
      <p>
        Esta plataforma está pensada para facilitar tu experiencia. Su uso debe ser responsable y respetuoso.
        Nos reservamos el derecho a <strong>modificar esta política</strong> cuando sea necesario, informando a los usuarios desde la web.
      </p>
      <h3>Gracias por confiar en Barber Mujica</h3>
      <p>
        Si todos colaboramos, el servicio fluye mejor.<br />
        Para cualquier duda puntual, puedes escribirnos por WhatsApp. Para todo lo demás, te esperamos en nuestra web.
      </p>
    </main>
  )
}

export default PoliticaDeServicio
